import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { PrintService } from 'src/app/services/print.service';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { CurriculumStore } from 'src/app/stores/resources/curriculum.store';
import { AddProgramLevelComponent } from '../add-program-level/add-program-level.component';

@Component({
  selector: 'app-program-level',
  templateUrl: './program-level.component.html',
  styleUrls: ['./program-level.component.scss']
})
export class ProgramLevelComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs: any = TABS.PROGRAM_LEVEL;
  PROGRAM_KEY: any;
  PROGRAM: any;

  LOADING: boolean = true;
  constructor(
    private route: ActivatedRoute,
    public store: CurriculumStore,
    private auth: AuthStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.LOADING=true;
    await this.auth.fetchUser()
    this.route.params.subscribe(async (param) => {
      this.PROGRAM_KEY = param['id'];
      this.tabs = TABS.PROGRAM_LEVEL.map(m => ({ path: `/programs/${this.PROGRAM_KEY}/${m.route}`, label: m.label }))
      await this.store.fetchProgram(this.PROGRAM_KEY);
      this.store.fetchProgramLevel(this.PROGRAM_KEY, res => {
        this.LOADING = false;
      });
    })
  }

  ngOnDestroy(): void {
    const { fetchProgramLevelRef } = this.store;
    fetchProgramLevelRef && fetchProgramLevelRef.unsubscribe();
  }

  addItem(item?: any) {
    let dialogRef = this.dialog.open(AddProgramLevelComponent, {
      data: {
        LEVEL: item || null,
        PROGRAM_KEY: this.PROGRAM_KEY,
      },
      panelClass: 'item-list-panel',
      width: '35vw',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {});
  }


  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: item,
      panelClass: 'cs-overlay-panel',
      width: '',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.store.removeLevelProgram(item, (success) => {
          if (success) {
            this.snackBar.open("Level has been removed successful.", "Done", { duration: 2500 });
          }
        })
      }
    });
  }
}
